import { lazy, Suspense } from 'react'
import { RouteObject } from 'react-router-dom'
import DotsLoading from 'components/loadings/dotsLoading'
import ErrorBug from 'components/errors/bugs'

// lazy: keeps recharts out of the main bundle, same as the admin dashboard
const Guarantees = lazy(() => import('./index'))

export const guaranteesRoutes: RouteObject[] = [
    {
        path: '/guarantees',
        errorElement: <ErrorBug />,
        element: (
            <Suspense fallback={<DotsLoading />}>
                <Guarantees />
            </Suspense>
        ),
    },
]
